import React, {useState, useEffect} from 'react';
import Time from '../../Time';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import AlertWindow from '../../Alert';
import Select from 'react-select';

class RequestTimeAjust extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        startDateTime:this.props.startTime,
        endDateTime:this.props.endTime,
        reason:"",
        totalHours:"",
        alertWindow:""
    };

    this.handleFormTimeChange = this.handleFormTimeChange.bind(this);
    this.makeRequest = this.makeRequest.bind(this)
    this.closeAlert = this.closeAlert.bind(this)

    this.startHours = React.createRef();
    this.endHours = React.createRef();

  }

  handleFormTimeChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});

    let startDateTime = this.state.startDateTime;
    let endDateTime = this.state.endDateTime;
    let totalHoursResult = new Date(endDateTime) - new Date(startDateTime);

    this.setState({totalHours:Time.convertSecondsToString(totalHoursResult/1000)})

  }

  makeRequest = (e)=>{

    e.preventDefault();

    var formdata = new FormData();
    formdata.append("endTimeDate", this.state.endDateTime);
    formdata.append("startTimeDate",this.state.startDateTime);
    formdata.append("shiftid", this.props.id);
    formdata.append("reason", this.state.reason);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/timesheet/requesttimechange.php", requestOptions)
      .then(response => response.text())
      .then(result => this.setState({alertWindow:result}))
      .catch(error => console.log('error', error));
  }

  //Closes the alert Window
  closeAlert = () =>{
    this.setState({alertWindow:""})
    this.props.update();
    this.props.close();
  }

  componentDidMount (){

    let startDateTime = this.props.startTime;
    let endDateTime = this.props.endTime;
    let totalHoursResult = new Date(endDateTime) - new Date(startDateTime);
    
    let treatResult = Time.convertSecondsToString(totalHoursResult/1000)

    this.setState({totalHours:treatResult})

  }

  render() {

    let startDateTime = this.props.startTime;
    let endDateTime = this.props.endTime;
    let totalHoursResult = new Date(endDateTime) - new Date(startDateTime);

    let alertWindowHTML
    if(this.state.alertWindow != ""){
      alertWindowHTML = <AlertWindow title="Success" message={this.state.alertWindow} close={this.closeAlert}/>
    }

    return(
      <div>
        {alertWindowHTML}
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window payroll-window">
            <div className="row">
                <div className="col-12 container p-4">
                    <h3>Request Time change</h3>
                </div>
            </div>
            <div>
              <form className='row container' onSubmit={this.makeRequest}>
                <div className='col-6'>
                    <div className="mb-3">
                        <label className="form-label">Start Date and Time</label>
                        <input onChange={this.handleFormTimeChange} defaultValue={startDateTime} type="datetime-local" className="form-control" id="startDateTime" required></input>
                    </div>
                </div>
                <div className='col-6'>
                    <div className="mb-3">
                        <label className="form-label">Finish Date and Time</label>
                        <input onChange={this.handleFormTimeChange} defaultValue={endDateTime} type="datetime-local" className="form-control" id="endDateTime" required></input>
                    </div>
                </div>
                <div className='col-12'>
                  <div class="mb-3">
                    <label for="exampleFormControlTextarea1" class="form-label">Reason for change</label>
                    <textarea onChange={this.handleFormTimeChange} class="form-control" id="reason" rows="3" required></textarea>
                  </div>
                </div>
                <div className='col-6'>
                    <div className="mb-3">
                        <p>Total: {this.state.totalHours}</p>
                    </div>
                </div>
                <div className="col-12 container p-4">
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button type='submit'>Request time change</button>
                    </div>
                </div>
              </form>
            </div>
        </div>
    </div>
    );
  }
}

export default RequestTimeAjust;